<p>shared-tournament-enroll works!</p>
